'use client';

import { SYD_TOWN_HALL } from '@workspace/constants';
import { ESearchZoomLevels } from '@/app/lib/store-locator-utils';
import { Map } from '@vis.gl/react-google-maps';
import { ReactNode } from 'react';

const mapId = process.env.NEXT_PUBLIC_GG_MAP_ID || 'DEMO_MAP_ID';

export const MapWrapper = ({ children }: { children: ReactNode }) => {
  return (
    <Map
      mapId={mapId}
      id={'store-locator-map'}
      defaultCenter={SYD_TOWN_HALL}
      defaultZoom={ESearchZoomLevels.LEVEL_1}
      minZoom={4}
      maxZoom={18}
      tilt={0}
      streetViewControl={false}
      mapTypeControl={false}
      fullscreenControl={false}
      // restriction={{
      //   latLngBounds: AustraliaBounds,
      // }}
    >
      {children}
    </Map>
  );
};
